<div class="wrapper">
  @if (isDataLoaded()) {
    <page-title></page-title>

    <!-- TimerPill. Renders only while something is actually being tracked and
         disappears completely when idle — there is no zeroed or placeholder
         state. Pink here means one thing: the timer is running. -->
    @if (isTimeTrackingEnabled() && currentTask(); as task) {
      <button
        class="timer-pill"
        (click)="stopTracking()"
        [matTooltip]="T.MH.TOGGLE_TRACK_TIME | translate"
        type="button"
      >
        <span class="timer-pill__dot sp-pulse-dot"></span>
        <span class="timer-pill__title">{{ task.title }}</span>
        <span class="timer-pill__elapsed sp-num">{{ task.timeSpent | msToString }}</span>
        <span class="timer-pill__stop"><mat-icon>stop</mat-icon></span>
      </button>
    }

    <nav class="action-nav-right">
      @if (isFocusModeEnabled()) {
        <!-- The component, not a plain button: it carries the running session
             countdown and cycle number, which a bare Focus button drops — so
             with the overlay closed there was nothing showing a session was
             still running. -->
        <focus-button></focus-button>
      }

      @if (isTaskViewCustomizerPage()) {
        <button
          class="ghost-btn"
          [class.isCustomized]="taskViewCustomizerService.isCustomized()"
          [matMenuTriggerFor]="customizerPanel.menu"
          type="button"
        >
          <mat-icon>filter_list</mat-icon>{{ T.MH.FILTER | translate }}
        </button>
        <task-view-customizer-panel #customizerPanel></task-view-customizer-panel>
      }

      <!-- Display holds everything the header used to spell out as a row of
           circular icon buttons. Nothing was deleted; it moved here. -->
      <button
        class="ghost-btn e2e-display-menu-btn"
        [matMenuTriggerFor]="displayMenu"
        type="button"
      >
        <mat-icon>tune</mat-icon>{{ T.MH.DISPLAY | translate }}
      </button>

      @if (isUserProfilesEnabled()) {
        <user-profile-button></user-profile-button>
      }
    </nav>

    <mat-menu
      #displayMenu="matMenu"
      class="display-menu"
    >
      <ng-template matMenuContent>
        <button
          (click)="layoutService.showAddTaskBar()"
          mat-menu-item
        >
          <mat-icon>add</mat-icon>
          <span
            >{{ T.MH.ADD_NEW_TASK | translate
            }}{{ kb.addNewTask ? ' · ' + kb.addNewTask : '' }}</span
          >
        </button>

        @if (isSyncIconEnabled()) {
          <button
            class="sync-btn"
            (click)="syncIsEnabledAndReady() ? sync() : setupSync()"
            mat-menu-item
          >
            <mat-icon [class.spin]="isSyncInProgress()">{{ syncGlyph() }}</mat-icon>
            <span>{{ T.MH.TRIGGER_SYNC | translate }}</span>
          </button>
        }

        <div class="display-menu__section">
          <plugin-work-context-header-btns></plugin-work-context-header-btns>
          <plugin-header-btns></plugin-header-btns>
          <plugin-side-panel-btns></plugin-side-panel-btns>

          <desktop-panel-buttons
            [kb]="kb"
            [isRouteWithSidePanel]="isRouteWithSidePanel()"
            [isShowScheduleDayPanel]="isShowScheduleDayPanel()"
            [isShowIssuePanel]="isShowIssuePanel()"
            [isShowNotes]="isShowNotes()"
          ></desktop-panel-buttons>
        </div>

        @if (enabledSimpleCounters().length) {
          <div class="display-menu__section">
            @for (
              simpleCounter of enabledSimpleCounters();
              track trackById($index, simpleCounter)
            ) {
              @if (!simpleCounter.isHideButton) {
                <simple-counter-button
                  [matTooltip]="simpleCounter.title"
                  [simpleCounter]="simpleCounter"
                ></simple-counter-button>
              }
            }
          </div>
        }
      </ng-template>
    </mat-menu>
  }
</div>
